import script from "./AlertComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertComponent.vue?vue&type=script&setup=true&lang=js"

import "./AlertComponent.vue?vue&type=style&index=0&id=e2a2f21e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2a2f21e"]])

export default __exports__